export class MissingFieldController {
    public static $inject: string[] = ["$mdDialog", "$mdMedia", "utilsService"];

    public $mdMedia: any;
    public sale: any; // bind from parent (SaleEditController::initiatePublish)

    private $mdDialog: any;

    constructor($mdDialog, $mdMedia, public utilsService) {
        this.$mdDialog = $mdDialog;
        this.$mdMedia = $mdMedia;
    }

    public hide() {
        this.$mdDialog.hide();
    }

    public hasInvalidItemsDescriptions(): boolean {
        return this.sale.items.some(item =>
            !item.valid &&
            (!item.description || item.description.length < this.sale.itemDescriptionMinLength)
        );
    }
}
